import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FiHome, FiHeart, FiUser } from "react-icons/fi";
import { IoMdHome, IoMdHeartEmpty, IoMdHeart } from "react-icons/io";
import { IoPersonCircle, IoPersonCircleOutline } from "react-icons/io5";
import LOGO from "../images/LOGO.png";
import "./Sidebar.css";

const Sidebar = ({ isAuth }) => {
  const location = useLocation();
  const isDetails = location.pathname.startsWith("/details");
  const isEditProfile = location.pathname === "/edit-profile";
  const isMyProfile = location.pathname === "/myprofile";

  useEffect(() => {
    if (isAuth && !isDetails && !isEditProfile && !isMyProfile) {
      document.body.classList.add("has-sidebar");
    } else {
      document.body.classList.remove("has-sidebar");
    }
  }, [isAuth, isDetails, isEditProfile, isMyProfile]);

  if (!isAuth || isDetails || isEditProfile || isMyProfile) return null;

  return (
    <>
      {/* -------------WEB-Sidebar---------------------- */}
      <nav className="app-sidenav">
        <div className="app-sidenav-logo">
          <img src={LOGO} alt="Logo" width="100px" height="100px" />
        </div>
        <NavLink
          to="/home"
          className={({ isActive }) =>
            `app-sidenav-item ${isActive ? "active" : ""}`
          }
        >
          <FiHome size={20} /> <span>Home</span>
        </NavLink>
        <NavLink
          to="/selected"
          className={({ isActive }) =>
            `app-sidenav-item ${isActive ? "active" : ""}`
          }
        >
          <FiHeart size={20} /> <span>Selected</span>
        </NavLink>
        <NavLink
          to="/profile"
          className={({ isActive }) =>
            `app-sidenav-item ${isActive ? "active" : ""}`
          }
        >
          <FiUser size={20} /> <span>Profile</span>
        </NavLink>
      </nav>

      {/* -----------------MOBILE-BottomBar------------------- */}
      <nav className="hp-bottom-nav">
        <NavLink
          to="/home"
          className={({ isActive }) =>
            `hp-nav-item ${isActive ? "active" : ""}`
          }
        >
          <IoMdHome size={22} /> <span>Home</span>
        </NavLink>
        <NavLink
          to="/selected"
          className={({ isActive }) =>
            `hp-nav-item ${isActive ? "active" : ""}`
          }
        >
          {({ isActive }) => (
            <>
              {isActive ? (
                <IoMdHeart size={22} />
              ) : (
                <IoMdHeartEmpty size={22} />
              )}
              <span>Selected</span>
            </>
          )}
        </NavLink>
        <NavLink
          to="/profile"
          className={({ isActive }) =>
            `hp-nav-item ${isActive ? "active" : ""}`
          }
        >
          {({ isActive }) => (
            <>
              {isActive ? (
                <IoPersonCircle size={26} />
              ) : (
                <IoPersonCircleOutline size={26} />
              )}
              <span>Profile</span>
            </>
          )}
        </NavLink>
      </nav>
    </>
  );
};

export default Sidebar;
